import React from "react";
import { Box, Typography, Button, makeStyles } from "@material-ui/core";
import { connect } from "react-redux";
import clsx from "clsx";
import { Link as RouterLink, Redirect } from "react-router-dom";
import AlertBox from "./MessageBox";
import { plans } from "../../data/plans";

const useStyles = makeStyles(theme => ({
  btn: {
    textTransform: "none",
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3)
  },
  btnGreen: {
    backgroundColor: "#07A35A",
    "&:hover": {
      backgroundColor: "#069250"
    }
  },
  bottomTitle: {
    fontSize: "1rem",
    marginBottom: theme.spacing(2)
  },
  bottomSubtitle: {
    fontSize: "0.75rem",
    lineHeight: "0.875rem",
    color: theme.palette.secondary.main,
    whiteSpace: "pre-line"
  },
  bottomPrice: {
    fontSize: "1.25rem",
    lineHeight: "1.5rem",
    marginBottom: theme.spacing(0.5),
    fontWeight: 900,
    "& span": {
      fontWeight: "normal",
      fontSize: "1rem"
    }
  },
  bottomPriceInfo: {
    fontSize: "0.6875rem",
    lineHeight: "0.75rem",
    textAlign: "right"
  },
  link: {
    fontSize: "0.75rem",
    lineHeight: "0.875rem",
    color: "#4D4D50",
    textDecoration: "underline",
    cursor: "pointer"
  }
}));

function PaymentInfo({
  showPrice,
  title,
  subtitle,
  btn,
  chosenPlan,
  vehiclesCount,
  currency,
  oldPlan
}) {
  const classes = useStyles();

  let downgrading = "";

  // Check if downgrading & to which plan is downgrading
  switch (chosenPlan.value) {
    case 0:
      if (oldPlan) downgrading = "basic";
      break;
    case 1:
      if (oldPlan === "business" || oldPlan === "enterprise")
        downgrading = "plus";
      break;
    case 2:
      break;
    default:
  }

  return chosenPlan && chosenPlan.price ? (
    <div>
      {
        <Box display="flex" justifyContent="center">
          <Box width="560px" px={3} pb={3} style={{ boxSizing: "border-box" }}>
            {
              <Box ml={-3} mr={-3}>
                {downgrading && (
                  <AlertBox
                    variant="warning"
                    subtitle={
                      downgrading === "basic" ? (
                        <>
                          Before downgrading your plan, remember that certain
                          features in your project may be disabled if they
                          exceed the usage limits of the {plans[0].title} plan.{" "}
                          <b>
                            Furthermore, all of your vehicles will be deleted as
                            you will only have access to 1 default vehicle in
                            the {plans[0].title} plan.
                          </b>
                        </>
                      ) : (
                        `Before downgrading your plan, remember that certain features in your project may be disabled if they exceed the usage limits of the ${plans[1].title} plan.`
                      )
                    }
                  />
                )}
                {/* )} */}
              </Box>
              // )
            }
            <Box display="flex" justifyContent="space-between" pt={4}>
              <Box width={showPrice ? "61%" : "100%"}>
                <Typography className={classes.bottomTitle}>{title}</Typography>
                <Typography className={classes.bottomSubtitle}>
                  {subtitle}
                </Typography>
              </Box>
              {showPrice && (
                <Box className={classes.cardSectionRight}>
                  <Typography className={classes.bottomPrice}>
                    {currency.symbol}
                    {chosenPlan.name === plans[0].name
                      ? chosenPlan.price
                      : vehiclesCount * chosenPlan.price}{" "}
                    <span>{currency.string}</span>
                  </Typography>
                  <Typography className={classes.bottomPriceInfo}>
                    Tax excluded
                  </Typography>
                </Box>
              )}
            </Box>

            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              marginTop={8}
            >
              {showPrice || oldPlan ? (
                <RouterLink className={classes.link} to="/payment/select-plan">
                  Back to previous step
                </RouterLink>
              ) : (
                <span></span>
              )}
              {
                <Button
                  variant="contained"
                  color="primary"
                  className={clsx(classes.btn, {
                    [classes.btnGreen]: btn.isGreen
                  })}
                  disableElevation
                  onClick={() => {
                    if (btn.text === "Done") {
                      btn.action();
                    } else {
                      btn.action({
                        plan_type: chosenPlan,
                        currency: currency.string.toLowerCase(),
                        vehicles: vehiclesCount
                      });
                    }
                  }}
                >
                  {btn.text}
                </Button>
              }
            </Box>
          </Box>
        </Box>
      }
    </div>
  ) : (
    <Redirect to="/payment/select-plan" />
  );
}

const mapStateToProps = state => ({
  vehiclesCount: state.project.vehicleTypes.length,
  userData: state.auth.userData
});

export default connect(mapStateToProps)(PaymentInfo);
